<template>
    <div class="marginCenter">
        <div class="title flex-yCenter marginBom38">
            <div class="line"></div>
            {{query.specialtyName}}
        </div>
        <PreviewEditor :value="html"></PreviewEditor>
        <div class="marginBom54 overflow">
            <div
                class="flex-column marginBom18 pointer"
                v-for="(item, index) in contnetObj.contentAtt"
                :key="index"
                @click="downLoadFile(item.url, item.name)"
            >
                <a class="fcolor_skyBlue">{{ item.name }}</a>
            </div>
        </div>
        <div class="flex-xCenter marginTop24 marginBom48"><el-button class="btn blueBtn2" @click="$router.go(-1)">返回</el-button></div>
    </div>
</template>
<script>
import PreviewEditor from '@/components/previewEditor'
import { trainContent } from '@/utils/api'
import { downLoadFile } from '@/utils/myUtil'
export default {
    components: { PreviewEditor },
    data() {
        return {
            query: {},
            html: '',
            contnetObj: {
                contentAtt: []
            }
        }
    },
    created() {
        this.query = this.$route.query
        trainContent(this.query.contentId).then(res => {
            if (res.code == 200) {
                this.html = res.data.content
                if (res.data.contentAtt) {
                    res.data.contentAtt = JSON.parse(res.data.contentAtt)
                }
                this.contnetObj = res.data
            }
        })
    },
    methods: {
        downLoadFile(url, src) {
            downLoadFile(url, src)
        }
    }
}
</script>
<style lang="scss" scoped>
.title {
    .line {
        width: 4px;
        height: 40px;
        background-color: #253D88;
        margin-right: 16px;
    }
    font-size: 32px;
    font-weight: 600;
}
.btn{
    width: 200px;
}
::v-deep img{
    max-width: 1200px;
}
</style>
